export default __webpack_public_path__ + "static/media/phn_img.63924cce.png";